import {
  BUSINESS_TYPE_LIMITED_COMPANY,
  BUSINESS_TYPE_LIMITED_LIABILITY_PARTNERSHIP,
  BUSINESS_TYPE_NOT_SURE,
  BUSINESS_TYPE_PARTNERSHIP,
  BUSINESS_TYPE_SOLE_TRADER,
  BUSINESS_TYPE_TRADING_TRUST
} from "./appConstants";
import { CompanyItemsData } from "../data/data";

export const BUSINESS_TYPE_PAYLOAD_MAP = {
  [BUSINESS_TYPE_NOT_SURE]: "NOT_SURE",
  [BUSINESS_TYPE_LIMITED_COMPANY]: "LIMITED_COMPANY",
  [BUSINESS_TYPE_SOLE_TRADER]: "SOLE_TRADER",
  [BUSINESS_TYPE_PARTNERSHIP]: "PARTNERSHIP",
  [BUSINESS_TYPE_LIMITED_LIABILITY_PARTNERSHIP]:
    "LIMITED_LIABILITY_PARTNERSHIP",
  [BUSINESS_TYPE_TRADING_TRUST]: "TRADING_TRUST"
};

export const mapBusinessTypeToPayload = (businessType) =>
  BUSINESS_TYPE_PAYLOAD_MAP[businessType] || null;

export const mapBusinessTypeFromPayload = (businessType) => {
  const match = CompanyItemsData.find(
    (item) => mapBusinessTypeToPayload(item.company) === businessType
  );
  return match?.company || BUSINESS_TYPE_LIMITED_COMPANY;
};
